module.exports = __webpack_public_path__ + "static/media/logov3transparent.c0c698e4.png";